export default __webpack_public_path__ + "static/Graphik-Bold-Web-0e4f186c632036a601dc60bc10afc815.woff";